export default "__VITE_ASSET__CxEjSjD6__"